// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3_PVg","row":"styles_row__22Qvq"};